import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';

import {FuseLoginComponent} from './login.component';

const routes = [{path: 'login', component: FuseLoginComponent}];

@NgModule({
  declarations: [FuseLoginComponent],
  imports: [SharedModule, RouterModule.forChild(routes)]
})

export class FuseLoginModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/login/login.module.ts